import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Activate from "@/pages/Activate";
import Community from "@/pages/Community";
import Classroom from "@/pages/Classroom";
import CoursePlayer from "@/pages/CoursePlayer";
import Members from "@/pages/Members";
import Leaderboard from "@/pages/Leaderboard";
import CPD from "@/pages/CPD";
import Resources from "@/pages/Resources";
import Verify from "@/pages/Verify";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { CalendarPage } from "@/pages/Placeholders";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminImport from "@/pages/admin/AdminImport";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAssessments from "@/pages/admin/AdminAssessments";
import AdminAudit from "@/pages/admin/AdminAudit";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="grid min-h-screen place-items-center text-muted-foreground">Loading…</div>;
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && !["super_admin", "trainer"].includes(user.role)) return <Navigate to="/community" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/activate" element={<Activate />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route element={<Protected><AppShell /></Protected>}>
              <Route index element={<Navigate to="/community" replace />} />
              <Route path="/community" element={<Community />} />
              <Route path="/classroom" element={<Classroom />} />
              <Route path="/classroom/:courseId" element={<CoursePlayer />} />
              <Route path="/members" element={<Members />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/cpd" element={<CPD />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/admin" element={<AdminOnly><AdminLayout /></AdminOnly>}>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="courses" element={<AdminCourses />} />
                <Route path="assessments" element={<AdminAssessments />} />
                <Route path="import" element={<AdminImport />} />
                <Route path="audit" element={<AdminAudit />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/community" replace />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
